module.exports = __webpack_public_path__ + "img/6.IG.5a39f802.jpg";